module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "py-1 px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "align-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.years,
      "label": _vm.$lang.actions.selectYear,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingYear)); }]
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.months,
      "label": _vm.$lang.actions.selectMonth,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingMonth)); }]
    },
    model: {
      value: (_vm.month),
      callback: function($$v) {
        _vm.month = $$v
      },
      expression: "month"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 mt-0 mx-4",
    attrs: {
      "color": "primary",
      "loading": _vm.loading,
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        return _vm.buildInvoice()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.generate))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08d8d495","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/InvoiceGenerateModal.vue
// module id = 567
// module chunks = 34